import { render, staticRenderFns } from "./ScanFormDPTableMobile.vue?vue&type=template&id=037e5c17&scoped=true"
import script from "./ScanFormDPTableMobile.vue?vue&type=script&lang=js"
export * from "./ScanFormDPTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037e5c17",
  null
  
)

export default component.exports